module.exports = __webpack_public_path__ + "static/WEDDING E&M-579-c69b6efd93df5f872c18637fc4ee1574.jpg";